import { Reducer, Action } from "redux";
import { IChildMonitoringServiceState, KnownAction, SET_IS_CHILD_ENROLLMENT_ALLOWED } from "./types";

export const reducer: Reducer<IChildMonitoringServiceState> = (
    state: IChildMonitoringServiceState | undefined,
    incomingAction: Action
): IChildMonitoringServiceState => {
    if (state === undefined) {
        return { isChildEnrollmentAllowed: true };
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case SET_IS_CHILD_ENROLLMENT_ALLOWED:
            return {
                ...state,
                isChildEnrollmentAllowed: action.isChildEnrollmentAllowed,
            };
        default:
            return state;
    }
};
